import React, {useMemo} from "react";
import {CBadge, CButton, CTooltip} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {cilCommentBubble, cilPencil, cilTrash, cilZoom} from "@coreui/icons";
import {PRIORITY_BADGE} from "../../config/constants";

const TaskCard = ({ task, onOpen, onDelete, onView, employeesById  }) => {
    const prColor = PRIORITY_BADGE[task.priority]
    const dueSoon = useMemo(() => {
        if (!task.dueDate) return false
        const today = new Date()
        const due = new Date(task.dueDate)
        const diff = (due - new Date(today.toDateString())) / (1000 * 60 * 60 * 24)
        return diff <= 2
    }, [task.dueDate])

    const assigneeName = useMemo(() => {
        if (!task.assignee) return ''
        const emp = employeesById?.[String(task.assignee)]
        return emp?.nombre || String(task.assignee)
    }, [employeesById, task.assignee])

    const commentsCount = task.comments?.length || 0

    return (
        <div className="bg-white rounded shadow-sm p-2 border">
            <div className="d-flex justify-content-between align-items-start">
                <div className="fw-semibold">{task.title}</div>
                <div className="d-flex gap-2 align-items-center">
                    {commentsCount > 0 && (
                        <CBadge color="primary" title="Comentarios" className="d-inline-flex align-items-center gap-1">
                            <CIcon icon={cilCommentBubble} size="sm" />
                            {commentsCount}
                        </CBadge>
                    )}
                    <CTooltip content="Ver">
                        <CButton size="sm" color="secondary" variant="ghost" aria-label="Ver tarea" onClick={onView}>
                            <CIcon icon={cilZoom} />
                        </CButton>
                    </CTooltip>
                    <CTooltip content="Editar">
                        <CButton size="sm" color="secondary" variant="ghost" aria-label="Editar tarea" onClick={onOpen}>
                            <CIcon icon={cilPencil} />
                        </CButton>
                    </CTooltip>
                    <CTooltip content="Eliminar">
                        <CButton size="sm" color="secondary" variant="ghost" aria-label="Eliminar tarea" onClick={onDelete}>
                            <CIcon icon={cilTrash} />
                        </CButton>
                    </CTooltip>
                </div>
            </div>
            <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
                <CBadge color={prColor}>Prioridad {task.priority}</CBadge>
                {task.assignee && <CBadge color="secondary">@{assigneeName}</CBadge>}
                {task.dueDate && (
                    <CBadge color={dueSoon ? 'danger' : 'secondary'}>venc: {new Date(task.dueDate).toLocaleDateString()}</CBadge>
                )}
            </div>
            {task.description && (
                <div className="text-muted small mt-2" style={{ whiteSpace: 'pre-wrap' }}>
                    {task.description}
                </div>
            )}
        </div>
    )
}

export default TaskCard;